import React from 'react';
import { Link } from 'react-router-dom';
import { Trans, useTranslation } from 'react-i18next';

import { authStyles } from './AuthPageLayout';

export const AuthLegalFooter: React.FC = () => {
  const { t } = useTranslation('auth');

  return (
    <p className={authStyles.legalConsent}>
      <Trans
        t={t}
        i18nKey="legalConsent"
        components={{
          terms: <Link className={authStyles.link} to="/legal/terms" />,
          privacy: <Link className={authStyles.link} to="/legal/privacy" />,
        }}
      />
    </p>
  );
};

export default AuthLegalFooter;
